import { motion } from "framer-motion";

const NODES = [
  { label: "Çocuk", angle: -90 },
  { label: "Ebeveyn", angle: -30 },
  { label: "Öğretmen", angle: 30 },
  { label: "Lider", angle: 90 },
  { label: "Kurum", angle: 150 },
  { label: "Birey", angle: 210 },
];

export function Orbit() {
  const radius = 158;
  return (
    <div data-testid="hero-orbit" className="relative w-[320px] h-[320px] sm:w-[400px] sm:h-[400px] mx-auto select-none">
      {/* rings */}
      <div className="absolute inset-0 rounded-full border border-brand-gold/30" />
      <div className="absolute inset-[38px] rounded-full border border-brand-gold/20" />
      <div className="absolute inset-[76px] rounded-full border border-brand-gold-light/40" />

      {/* rotating orbit layer */}
      <div className="absolute inset-0 animate-spin-slow">
        {NODES.map((n, i) => {
          const rad = (n.angle * Math.PI) / 180;
          const x = Math.cos(rad) * radius;
          const y = Math.sin(rad) * radius;
          return (
            <div
              key={n.label}
              className="absolute top-1/2 left-1/2"
              style={{ transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))` }}
            >
              <div className="animate-spin-slow" style={{ animationDirection: "reverse" }}>
                <span className="block whitespace-nowrap bg-brand-offwhite border border-brand-gold-light/60 text-brand-green text-xs sm:text-sm font-medium px-3 py-1.5 rounded-full shadow-sm">
                  {n.label}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {/* center */}
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-28 h-28 sm:w-32 sm:h-32 rounded-full bg-brand-green flex flex-col items-center justify-center text-center"
      >
        <span className="font-serif text-brand-offwhite text-xl sm:text-2xl leading-none">Bilgece</span>
        <span className="text-brand-gold-light text-[10px] tracking-widest mt-1">EKOSİSTEM</span>
      </motion.div>
    </div>
  );
}
